import type { Ancora } from '@plane/shared';
import type { UseFormRegisterReturn } from 'react-hook-form';

/**
 * Escolhe uma seção do site como destino de um link.
 *
 * Lista fechada de propósito: campo livre já produziu, neste projeto, links
 * apontando para seção que não existe. Aqui o destino inválido não é digitável.
 */
const ANCORAS: readonly { readonly valor: Ancora; readonly rotulo: string }[] = [
  { valor: '#atelie', rotulo: 'Ateliê' },
  { valor: '#ambientes', rotulo: 'Ambientes' },
  { valor: '#projetos', rotulo: 'Projetos' },
  { valor: '#processo', rotulo: 'Processo' },
  { valor: '#showroom', rotulo: 'Showroom' },
  { valor: '#orcamento', rotulo: 'Orçamento' },
];

export function SeletorDeAncora({
  id,
  rotulo,
  registro,
}: {
  id: string;
  rotulo: string;
  registro: UseFormRegisterReturn;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-xs tracking-[0.12em] text-ink-soft uppercase">
        {rotulo}
      </label>
      <select
        id={id}
        className="border border-clay bg-white px-3 py-2.5 text-sm transition-colors focus:border-brand-600 focus:outline-none"
        {...registro}
      >
        {ANCORAS.map((ancora) => (
          <option key={ancora.valor} value={ancora.valor}>
            {ancora.rotulo}
          </option>
        ))}
      </select>
    </div>
  );
}
